import "../../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import { useTheming as useTheming$1, Theme } from "@odin/services";
import { ref } from "../../../node_modules/.pnpm/@vue_reactivity@3.5.13/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.es.js";
const _theme = ref(Theme.CARY);
const useTheming = () => {
  return {
    theme: _theme,
    isTheme,
    setTheme
  };
};
const isTheme = (theme) => {
  return _theme.value === theme;
};
const setTheme = (theme) => {
  _theme.value = theme;
};
const themingPlugin = {
  install: (app) => {
    const { theme, onTheme } = useTheming$1();
    _theme.value = theme;
    onTheme((value) => _theme.value = value);
    app.config.globalProperties.$theme = _theme;
  }
};
export {
  themingPlugin as default,
  useTheming
};
//# sourceMappingURL=theming.es.js.map
